export const insertPageAction = {
  setShowActionMenu: (state, action) => {
    state.showActionMenu = action.payload;
  },

  setFileToAttachToReport: (state, action) => {
    state.fileToAttachToReport = { ...action.payload };
  },

  setOriginalFileToAttachToReport: (state, action) => {
    state.originalFileToAttachToReport = { ...action.payload };
  },

  setFileToAttachSelected: (state, action) => {
    state.fileToAttachSelected = action.payload;
  },

  setUpdatedTransmissionReportFile: (state, action) => {
    state.updatedTransmissionReportFile = action.payload;
  },

  setTransmissionReportFileEnableCache: (state, action) => {
    state.transmissionReportFileEnableCache = action.payload;
  },
};
